var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "notification-preferences" },
    _vm._l(
      _setup.notificationOptions.filter((e) => {
        return !e.permission || _vm.can(e.permission)
      }),
      function (option) {
        return _c(
          "div",
          { key: option.title },
          [
            _c("v-card-subtitle", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(option.title)),
            ]),
            _vm._v(" "),
            _c(
              "v-card-text",
              [
                _c(
                  "v-btn-toggle",
                  {
                    attrs: {
                      value:
                        _setup.formatNotificationPreferences[option.category],
                      multiple: "",
                      rounded: "",
                    },
                  },
                  _vm._l(option.channels, function (notification, key) {
                    return _c(
                      "v-btn",
                      {
                        key: key,
                        attrs: {
                          value: notification,
                          small: "",
                          "active-class": "primary--text",
                          dense: "",
                        },
                        on: {
                          click: function ($event) {
                            _vm.value[option.category][notification] =
                              !_vm.value[option.category][notification]
                          },
                        },
                      },
                      [_vm._v(_vm._s(notification))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }
    ),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }